/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2, useTheme } from '@coursera/cds-core';

// i18n
import _t from 'i18n!nls/teams-v2';

type Props = {
  discountPercent: number | null;
  promotionName: string;
};

function DiscountPill({ discountPercent, promotionName }: Props) {
  const theme = useTheme();
  return (
    <div
      css={{
        display: 'inline-flex',
        alignItems: 'center',
        paddingLeft: 'var(--cds-spacing-200)',
        paddingRight: 'var(--cds-spacing-200)',
        height: 32,
        borderRadius: 16,
        background: 'var(--cds-color-grey-50)',
      }}
    >
      <Typography2 variant="subtitleMedium" component="div">
        <FormattedMessage
          message={_t(`with {discountPercentage}% {discountName} discount`)}
          discountPercentage={discountPercent ?? 0}
          discountName={promotionName}
        />
      </Typography2>
    </div>
  );
}

export default DiscountPill;
